import { createModule } from '../createModule';
import { IPaymentStatus } from '@/models';

export const paymentStatus = createModule<IPaymentStatus>('paymentStatus', {
    url: 'payment_status'
});